import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { intlShape } from "react-intl";
import SubCategoryInfo from "./SubCategoryInfo";
import { CATEGORY_BACKGROUND_COLOR } from "./constants";
import messages from "../../../messagesDescription";

const CategoryInfo = ({ data, currencyCode, intl }) => {
  const hasData = data.subCategoryList.find(itm => itm.subSubCategoryList.length > 0);
  return (
    <div key={data.categoryName} style={{ marginBottom: "3em" }}>
      <div
        style={{
          fontSize: "1.25em",
          marginBottom: "1em",
          padding: "5px",
          backgroundColor: CATEGORY_BACKGROUND_COLOR,
        }}
      >
        <a
          id={data.categoryName}
          href="?"
          onClick={e => e.preventDefault()}
          style={{ textDecoration: "none" }}
        >
          <span style={{ color: "black" }}>
            <strong>
              {intl.formatMessage({
                id: data.categoryName,
                defaultMessage: data.categoryName,
              })}
            </strong>
          </span>
        </a>
      </div>

      {hasData ? (
        <Fragment>
          <p style={{ fontSize: "0.875em" }}>
            {intl.formatMessage({
              id: data.categoryNotes,
              defaultMessage: data.categoryNotes,
            })}
          </p>
          <div>
            {data.subCategoryList &&
              data.subCategoryList.map(item => {
                return (
                  item.subSubCategoryList.length > 0 && (
                    <SubCategoryInfo
                      key={item.subCategoryName}
                      data={item}
                      currencyCode={currencyCode}
                      intl={intl}
                    />
                  )
                );
              })}
          </div>
          {data.categoryFootNotes && (
            <p style={{ fontSize: "0.875em", marginTop: "50px" }}>
              {intl.formatMessage({
                id: data.categoryFootNotes,
                defaultMessage: data.categoryFootNotes,
              })}
            </p>
          )}
          {data.advertisement.map(data => {
            return (
              <div
                key={data}
                dangerouslySetInnerHTML={{
                  __html: intl.formatMessage({
                    id: data,
                    defaultMessage: data,
                  }),
                }}
              />
            );
          })}
        </Fragment>
      ) : data.advertisement && data.advertisement.length > 0 ? (
        data.advertisement.map(data => {
          return (
            <div
              key={data}
              dangerouslySetInnerHTML={{
                __html: intl.formatMessage({
                  id: data,
                  defaultMessage: data,
                }),
              }}
            />
          );
        })
      ) : (
        <p>
          <strong>{intl.formatMessage({ ...messages.noTotalRewards })}</strong>
        </p>
      )}
    </div>
  );
};
CategoryInfo.propTypes = {
  data: PropTypes.object,
  currencyCode: PropTypes.string,
  intl: intlShape.isRequired,
};

export default CategoryInfo;



// WEBPACK FOOTER //
// ./components/employee/benefits/trs/CategoryInfo.jsx